import { useState, useEffect, useRef } from "react";
import Table from "../../../components/utils/Table";
import { useForm } from "react-hook-form";
import moment from "moment";
import Button from "../../../components/utils/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  removeExtraSpaces,
  uniqArrayOfObject,
} from "../../../helpers/commonFunction";
import Calendar2LineIcon from "remixicon-react/Calendar2LineIcon";
import DatePicker from "react-datepicker";
import CheckLineIcon from "remixicon-react/CheckLineIcon";
import CloseLineIcon from "remixicon-react/CloseLineIcon";
import NetworkActions from "../../../redux/network/actions";
import shortCodeActions from "../../../redux/shortCodeData/actions";
import SimPinActions from "../../../redux/SIMPINInventory/actions";

const { getShortCode } = shortCodeActions;

const { getSimPinInventory, resetSimPinInventoryMessage, addSimPinInventory } =
  SimPinActions;
const { getActiveNetwork } = NetworkActions;

const AddSimPinInventory = ({ back, searchData }) => {
  const dispatch = useDispatch();
  const datePickerRef = useRef(null);
  const [toDate, setToDate] = useState(new Date());
  const [previewData, setPreviewData] = useState([]);
  const [previewSuccessData, setPreviewSuccessData] = useState([]);
  const [previewFailedData, setPreviewFailedData] = useState([]);
  const [previewSuccessCount, setPreviewSuccessCount] = useState(0);
  const [showPreviewType, setShowPreviewType] = useState(2);
  const [networkId, setNetworkId] = useState(0);
  const { shortCodeResult } = useSelector((state) => state.shortCode);
  const {
    inventoryData,
    addSimPinInventoryMessage,
    addSimPinInventoryLoading,
    addSimPinInventoryError,
  } = useSelector((state) => state.simPinInventory);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    clearErrors,
    setValue,
    reset,
  } = useForm({ defaultValues: {} });
  const { networkResult } = useSelector((state) => state.network);

  useEffect(() => {
    dispatch(getActiveNetwork());
    dispatch(
      getShortCode({
        tableName: "plan",
        fieldName: "PINValue",
      }),
    );
    dispatch(getSimPinInventory());
    reset();
  }, [dispatch]);

  useEffect(() => {
    if (addSimPinInventoryMessage || addSimPinInventoryError) {
      back();
      dispatch(resetSimPinInventoryMessage());
    }
  }, [addSimPinInventoryMessage, addSimPinInventoryError]);
  const activeNetworks = networkResult?.filter(
    (item) => item.IsActive == 1 && item.ID == 1,
  );

  useEffect(() => {
    if (activeNetworks?.length === 1) {
      setValue("networkID", activeNetworks[0].ID);
      setNetworkId(activeNetworks[0].ID);
    }
  }, [networkResult]);

  const previewColumns = [
    { displayName: "SIM PIN", key: "SimPinNumber" },
    { displayName: "REASON", key: "Reason" },
    { displayName: "VALID", key: "Valid" },
  ];

  const openDatePicker = () => {
    datePickerRef.current.setOpen(true);
  };

  const handleTextareaChange = (val) => {
    setPreviewSuccessCount(0);
    setPreviewData([]);
    clearErrors(["inputData"]);

    const dataArr = val.trim() !== "" ? val.trim().split("\n") : [];

    const previewdata = dataArr.map((item) => {
      let simPinNumber = removeExtraSpaces(item);
      let error = false;
      let reason = "";

      if (!/^\d{12}$/.test(simPinNumber)) {
        reason = "Invalid SIM PIN Number";
        error = true;
      }

      if (!error) {
        reason = "Valid";
        setPreviewSuccessCount((pre) => pre + 1);
      }

      return {
        SimPinNumber: simPinNumber,
        Reason: reason,
        Valid: error ? (
          <CloseLineIcon color="#e74c3c" />
        ) : (
          <CheckLineIcon color="#2ecc71" />
        ),
        Status: error ? 0 : 1,
      };
    });

    const uniqueSerialNumberArr = uniqArrayOfObject(
      previewdata,
      "SimPinNumber",
    );

    if (uniqueSerialNumberArr.length !== previewdata.length) {
      setError("inputData", {
        type: "custom",
        message: "Data contain duplicate SIM PIN",
      });
      return false;
    }

    if (previewdata.length > 10000) {
      setError("inputData", {
        type: "custom",
        message: "Data should not be more than 10000 rows",
      });
      return false;
    }

    if (previewdata.length > 0) {
      setPreviewData(previewdata);
    }
  };

  const handlePreviewTableData = (id) => {
    setShowPreviewType(id);
  };

  const handleNetwork = (e) => {
    e.preventDefault();
    setNetworkId(e.target.value);
  };

  const handleAddSimPinInventory = (data) => {
    const requestData = previewData.map((item) => ({
      SimPinNumber: item.SimPinNumber,
    }));
    data.purchaseDate = moment(toDate).format("YYYY-MM-DD");
    data.purchaseNumber = inventoryData.PurchaseNumber;
    data.invoiceNumber = inventoryData.InvoiceNumber;
    data.requestData = requestData;
    dispatch(addSimPinInventory(data, searchData));
    console.log(data);
  };

  return (
    <>
      <div className="row align-items-center mb-3">
        <div className="col-md-12 mb-2">
          <form onSubmit={handleSubmit(handleAddSimPinInventory)}>
            <div className="row">
              <div className="col-md-2 mb-3">
                <label className="ml-2">
                  {" "}
                  Network <span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  placeholder="Select Network"
                  name="networkID"
                  {...register("networkID", {
                    required: "Network is Required",
                  })}
                  onChange={(e) => {
                    handleNetwork(e);
                  }}
                >
                  {/* <option value="" key="0">
                    Select
                  </option> */}
                  {networkResult
                    .filter((network) => network.ID == 1)
                    .map((network) => (
                      <option
                        name="network"
                        value={network.ID}
                        key={network.ID}
                      >
                        {network.NetworkName}
                      </option>
                    ))}
                </select>
                {errors && errors.networkID && (
                  <div className="invalid-feedback">
                    {errors.networkID.message}
                  </div>
                )}
              </div>

              <div className="col-md-2 mb-3">
                <label>
                  PIN Price<span className="text-danger ml-1">*</span>
                </label>

                <select
                  className="form-control"
                  {...register("pinValue", {
                    required: "PIN Price is Required",
                  })}
                >
                  <option value="">Select</option>

                  {shortCodeResult
                    ?.filter((item) => item.IsActive == 1)
                    .map((item) => (
                      <option key={item.ID} value={item.Value}>
                        ${item.Value}
                      </option>
                    ))}
                </select>

                {errors.pinValue && (
                  <div className="invalid-feedback d-block">
                    {errors.pinValue.message}
                  </div>
                )}
              </div>

              <div className="col-lg-2 col-md-2 mb-2 d-flex flex-column">
                <label>
                  Purchase Date <span className="text-danger ml-1">*</span>
                </label>
                <Calendar2LineIcon
                  onClick={openDatePicker}
                  size={"1.5rem"}
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    top: "36px",
                    right: "22px",
                    zIndex: 1,
                  }}
                />
                <DatePicker
                  ref={datePickerRef}
                  selected={toDate}
                  className="form-control"
                  onChange={(date) => setToDate(date)}
                  dateFormat="yyyy-MM-dd"
                  name="toDate"
                  showMonthDropdown
                  showYearDropdown
                  onKeyDown={(e) => {
                    e.preventDefault();
                  }}
                  maxDate={new Date()}
                  value={toDate}
                  // disabled={true}
                />
              </div>
              <div className="col-lg-3">
                <label>
                  Purchase Number<span className="text-danger ml-1">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Purchase Number"
                  disabled={true}
                  className="form-control"
                  name="purchaseNumber"
                  value={inventoryData.PurchaseNumber}
                />
              </div>
              <div className="col-lg-3">
                <label>
                  Invoice Number <span className="text-danger ml-1">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Invoice Number"
                  disabled={true}
                  className="form-control"
                  name="invoiceNumber"
                  value={inventoryData.InvoiceNumber}
                />
              </div>
              {networkId != 0 && (
                <div className="col-lg-6">
                  <label htmlFor="data">
                    SIM PIN<span className="text-danger ml-1">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    id="data"
                    rows="4"
                    style={{ resize: "none" }}
                    onChange={(e) => handleTextareaChange(e.target.value)}
                  ></textarea>
                  {errors && errors.inputData && (
                    <div className="invalid-feedback">
                      {errors.inputData.message}
                    </div>
                  )}
                </div>
              )}
              {networkId != 0 && (
                <div className="col-lg-6">
                  <label htmlFor="data" className="example-label">
                    Example
                  </label>
                  <div className="data-row">
                    <span className="data-heading">SIM PIN</span>
                  </div>
                  <div className="data-row">
                    <span>643376312849</span>
                  </div>
                  <div className="data-row">
                    <span>469547489204</span>
                  </div>
                  <div className="data-row">
                    <span className="data-dot">.....</span>
                  </div>
                </div>
              )}
            </div>

            {previewData.length > 0 && (
              <>
                <hr />
                <div className="row p-0 m-0" style={{ cursor: "pointer" }}>
                  <div
                    className="col-md-4 d-flex justify-content-around align-items-center py-3 preview-box"
                    onClick={() => {
                      handlePreviewTableData(2);
                    }}
                  >
                    <h4>Total Submitted : {previewData.length}</h4>
                  </div>
                  <div
                    className="col-md-4 d-flex justify-content-around align-items-center preview-box"
                    onClick={() => {
                      handlePreviewTableData(1);
                    }}
                  >
                    <h4 className="text-success">
                      Valid : {previewSuccessCount}
                    </h4>
                  </div>
                  <div
                    className="col-md-4 d-flex justify-content-around align-items-center preview-box"
                    onClick={() => {
                      handlePreviewTableData(0);
                    }}
                  >
                    <h4 className="text-danger">
                      Invalid : {previewData.length - previewSuccessCount}
                    </h4>
                  </div>
                </div>
                <div className="col-md-12 mb-3 p-0">
                  <Table
                    columns={previewColumns}
                    data={
                      showPreviewType == 1
                        ? previewSuccessData
                        : showPreviewType == 0
                          ? previewFailedData
                          : previewData
                    }
                    pagination={false}
                  />
                </div>
              </>
            )}
            <div className="text-right row mt-2">
              <div className="col-md-12">
                <button
                  type="button"
                  className="btn btn-secondary mr-2"
                  onClick={() => back()}
                >
                  Close
                </button>
                {previewData.length > 0 && (
                  <Button
                    loading={addSimPinInventoryLoading}
                    title="Submit"
                    disable={previewData.length - previewSuccessCount !== 0}
                    style="minWidth:80px"
                    buttonClass="btn btn-primary"
                    buttonType="submit"
                  />
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddSimPinInventory;
